import React from 'react';
import { TabBarContainer, TabBarItem } from './styled';

function TabBar(props) {

    const nameList = props.list;
    const length = nameList.length;
    const current = props.current;

    return (
        <TabBarContainer>
            {nameList.map((name, idx) => {
                console.log(current)
                return <TabBarItem num={length} selected={name === current} onClick={() => props.setCurrent(name)}>{name}</TabBarItem>
            })}
        </TabBarContainer>
    );
}

export default TabBar;